import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { fromEvent, of } from 'rxjs';
import { filter, map, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNConsultation, CNConsultationType } from 'src/app/models/cnconsultation';
import { ContactService } from 'src/app/services/contact.service';
import { PatientService } from 'src/app/services/patient.service';
import { UserConfigService } from 'src/app/services/user-config.service';
import { UserOpenItemsService } from 'src/app/services/user-open-items.service';
import { ContactTableComponent } from '../contact-table/contact-table.component';

declare var Ext: any;

@ManageType('ContactsPanelComponent')
@Component({
  selector: 'app-contacts-panel',
  templateUrl: './contacts-panel.component.html',
  styleUrls: ['./contacts-panel.component.scss']
})
export class ContactsPanelComponent implements OnInit {

  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
  @ViewChild('contactTable', { static: true }) contactTable: ContactTableComponent;
  public isSearching = false;

  constructor(private patient: PatientService, private ngZone: NgZone,
              public userConfig: UserConfigService, public contactservice: ContactService,
              private userOpenItemsSrv: UserOpenItemsService) { }

  ngOnInit(): void {
    fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
      // get value
      map((event: any) => {
        return event.target.value;
      })
      , filter(res => res.length > 2)
      , debounceTime(500)
      , distinctUntilChanged()
      // subscription for response
    ).subscribe((text: string) => {
      this.isSearching = true;
    }, (err) => {
      this.isSearching = false;
      console.log('error', err);
    });
  }

  newContact() {
    if (this.contactservice.useOld) {
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          const consultationWindow = new Ext.CNConsultationWindow({
            patientid: this.patient.patient.id,
            displayconsult: true,
            displayservicecode: true,
            prestataireid: this.userConfig.userid,
            closewhensaved: true,
            displaybillbutton: false,
            source: 'patientsearch',
            displaycontacttype: this.userConfig.profileValue('CNConsultation', 'displaycontacttype')
          });
          consultationWindow.show();
          consultationWindow.on('consultationAdded', () => {
            setTimeout(() => {
              this.reload();
            });
          });
        });
      });
    } else {
      // new contact
      const newCons = new CNConsultation();
      // tslint:disable-next-line:max-line-length
      newCons.type = (this.userConfig.profileValue('CNConsultation', 'default') === false) ? CNConsultationType.Simple : this.userConfig.profileValue('CNConsultation', 'default') as CNConsultationType;
      newCons.setProperty('healthagentid', this.userConfig.userid);
      newCons.date = new Date();
      this.userOpenItemsSrv.addItem(newCons , true);
    }
  }

  reload() {
    this.ngZone.run(() => {
      this.contactservice.dataStart = 0;
      this.contactservice.load();
    });
  }
}
